import { sessionPrefix } from "./helpers";

export const knowledgebaseQuestionsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/knowledgebase`;
export const newKnowledgebaseQuestionPath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/knowledgebase/new`;
export const showKnowledgebaseQuestionPath = (session: LightSessionInterface, question: KnowledgebaseQuestionRef) =>
  `${sessionPrefix(session)}/knowledgebase/${question.id}`;
